module.exports = __webpack_public_path__ + "img/cv.ba6b34a5.svg";